module.exports = __webpack_public_path__ + "static/img/yixipaidprogram.ca2299e4.png";